export type LoginFields = {
  email: string;
  password: string;
};

export type RegisterFields = {
  email: string;
  phoneNumber: string;
  companyName: string;
  password: string;
  role: string;
  callback?: string;
};

export type ForgotFields = {
  email: string;
  callback: string;
};

export type ResetFields = {
  token: string;
  password: string;
  passwordRepeat: string;
};

export enum Role {
  AdPartner = 'AD_PARTNER',
  TaxiPartner = 'TAXI_PARTNER',
}
